import React, { useState } from 'react';
import styles from './Menubar.module.css';
import DropDownIcon from '../../../../Components/Icons/DropDownIcon';

const Menubar = ({ activeReport, setActiveReport }) => {
	const [isStaffExpanded, setIsStaffExpanded] = useState(true);
	const [isSalesExpanded, setIsSalesExpanded] = useState(true);
	const [isPaymentsExpanded, setIsPaymentsExpanded] = useState(true);

	const staffMenuItems = [
		{ id: 'leave', label: 'Leave' },
		{ id: 'break', label: 'Break' },
		{ id: 'payroll', label: 'Payroll' }
	];

	const salesMenuItems = [
		{ id: 'salesSummary', label: 'Sales Summary' },
		{ id: 'sales', label: 'Product Sales' }
	];

	const paymentsMenuItems = [
		{ id: 'paymentSummary', label: 'Payment Summary' },
		{ id: 'paymentDetails', label: 'Payment Details' }
	];

	const toggleStaffSection = () => setIsStaffExpanded((prev) => !prev);
	const toggleSalesSection = () => setIsSalesExpanded((prev) => !prev);
	const togglePaymentsSection = () => setIsPaymentsExpanded((prev) => !prev);

	return (
		<div className={styles.menubarContainer}>
			<h3 className={styles.menuHeader}>Reports</h3>
			
			{/* Staff Section */}
			<div 
				className={styles.categoryHeader}
				onClick={toggleStaffSection}
			>
				<span>Staff</span>
				<DropDownIcon 
					className={`${styles.dropdownIcon} ${isStaffExpanded ? styles.rotated : ''}`}
				/>
			</div>
			{isStaffExpanded && (
				<div className={styles.menuList}>
					{staffMenuItems.map((item) => (
						<div
							key={item.id}
							className={`${styles.menuItem} ${
								activeReport === item.id ? styles.active : ''
							}`}
							onClick={() => setActiveReport(item.id)}
						>
							{item.label}
						</div>
					))}
				</div>
			)}

			<div className={styles.divider}></div>

			{/* Sales Section */}
			<div 
				className={styles.categoryHeader}
				onClick={toggleSalesSection}
			>
				<span>Sales</span>
				<DropDownIcon 
					className={`${styles.dropdownIcon} ${isSalesExpanded ? styles.rotated : ''}`}
				/>
			</div>
			{isSalesExpanded && (
				<div className={styles.menuList}>
					{salesMenuItems.map((item) => (
						<div
							key={item.id}
							className={`${styles.menuItem} ${
								activeReport === item.id ? styles.active : ''
							}`}
							onClick={() => setActiveReport(item.id)}
						>
							{item.label}
						</div>
					))}
				</div>
			)}

			<div className={styles.divider}></div>

			{/* Payments Section */}
			<div 
				className={styles.categoryHeader}
				onClick={togglePaymentsSection}
			>
				<span>Payments</span>
				<DropDownIcon 
					className={`${styles.dropdownIcon} ${isPaymentsExpanded ? styles.rotated : ''}`}
				/>
			</div>
			{isPaymentsExpanded && (
				<div className={styles.menuList}>
					{paymentsMenuItems.map((item) => (
						<div
							key={item.id}
							className={`${styles.menuItem} ${
								activeReport === item.id ? styles.active : ''
							}`}
							onClick={() => setActiveReport(item.id)}
						>
							{item.label}
						</div>
					))}
				</div>
			)}

			<div className={styles.divider}></div>

			{/* Cancellation Report - Main Section */}
			<div 
				className={`${styles.mainSection} ${
					activeReport === 'cancellation' ? styles.active : ''
				}`}
				onClick={() => setActiveReport('cancellation')}
			>
				Cancellation 
			</div>

			{/* PLU Report - Main Section */}
			<div
				className={`${styles.mainSection} ${
					activeReport === 'plu' ? styles.active : ''
				}`}
				onClick={() => setActiveReport('plu')}
			>
				PLU Report
			</div>

			{/* Check-in Report - Main Section */}
			<div 
				className={`${styles.mainSection} ${
					activeReport === 'checkin' ? styles.active : ''
				}`}
				onClick={() => setActiveReport('checkin')}
			>
				Check-in 
			</div>
		</div>
	);
};

export default Menubar;

